import { Theme } from '@mui/material/styles';

export const Styles = {
    body: (theme: Theme) => ({
        marginLeft: theme.spacing(3),
    }),
};
